import {inject, Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree} from '@angular/router';
import {Observable} from 'rxjs';
import {AuthService} from "@app/services";

@Injectable({
  providedIn: 'root'
})
export class AuthGuard {
  private auth: AuthService = inject(AuthService);
  private router: Router = inject(Router);

  constructor() {
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.auth.isAuthenticated() || this.auth.ensureSessionLoaded().then((result) => {
      if (result) {
        return true;
      }

      console.log('[AuthGuard] User is not authenticated, redirecting to login page');
      this.router.navigate(['/user/login'], {
        queryParams: {
          redirectUrl: state.url,
        }
      });
      return false;
    });
  }

}
